import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface CPDialogAction {
  text: string;
  onClick: () => void;
}

interface CPDialogProps {
  open: boolean;
  title: string;
  content: string;
  actions: CPDialogAction[];
  onClose?: () => void;
}

export const CPDialog = ({ actions = [], ...props }: CPDialogProps) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box padding={1}>
        <DialogTitle id="alert-dialog-title">
          <b>{props.title}</b>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={props.onClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent className="mt-2">
          <DialogContentText id="alert-dialog-description">
            {props.content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {actions.map((action) => (
            <Button variant="contained" onClick={action.onClick}>
              {action.text}
            </Button>
          ))}
        </DialogActions>
      </Box>
    </Dialog>
  );
};
